import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=f0f6ab0c&scoped=true"
import script from "./WarningIcon.vue?vue&type=script&lang=js"
export * from "./WarningIcon.vue?vue&type=script&lang=js"
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=f0f6ab0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f6ab0c",
  null
  
)

export default component.exports